import React from "react";
import { MdPushPin, MdOutlinePushPin } from "react-icons/md";
import { PERMISSION } from  "../constants";
import { IconStyled, IconPinStyle } from "../style";
import { isCheckPermission } from "../../localuser/functions";
import { connect } from "../../redux";
import { deletePinParticipant, pinParticipant } from "../actions";

function PinnedParticipant({
    dispatch, participantId, pinLayoutMode, pinned, isPinPermission, hidePinLayout, hover = true
}) {
    if (!APP.function.pin) return null;
    
    const setPinned = () => {
        if (!hover) return;
        if (!isPinPermission) return;
        
        if (!pinned) {
            dispatch(pinParticipant(participantId));
            APP.mateManagement.setPinned(participantId);
        } else {
            dispatch(deletePinParticipant(participantId));
            APP.mateManagement.removePinned(participantId);
        }
    }

    return (
        <span>
            {
                hidePinLayout && (
                    <>
                        { pinLayoutMode ?
                            <IconPinStyle isPointer={hover && isPinPermission} onClick={setPinned}>
                                { pinned ? <MdPushPin color="#29abe2" /> : <MdOutlinePushPin color="#d5d5d5"/> }                        
                            </IconPinStyle>
                        :
                            <IconStyled className="pinIcon" isPointer={hover && isPinPermission} isOn={pinned} onClick={setPinned}>
                                <MdPushPin />
                            </IconStyled> }
                    </>
                )
            }
        </span>
    )
}

function _mapStateToProps(state) {
    return {
        isPinPermission: isCheckPermission(state, PERMISSION.PIN),
    }
}

export default connect(_mapStateToProps)(PinnedParticipant);